// One reader for the error bodies our Pages Functions return.
//
// apiGet/postJson/apiDelete wrap a failure as `HTTP <status>: <raw body>`, and our
// proxies answer `{error, detail?}` where `detail` is the Thai sentence staff can
// act on. Three near-copies of this had already appeared (employeeSchedule.js, and
// local ones in two new files), each reading a different subset of the keys — the
// weakest dropped `error`, so a proxy that only sets that key surfaced raw JSON to
// a Thai-speaking front desk.
export function apiErrorText(e, fallback = 'ทำรายการไม่สำเร็จ') {
  const s = String(e?.message || e || '')
  const m = /\{[\s\S]*\}$/.exec(s)
  if (m) {
    try {
      const j = JSON.parse(m[0])
      const t = j?.detail || j?.message || j?.error
      if (t) return String(t)
    } catch { /* not JSON — fall through to the raw string */ }
  }
  return s || fallback
}

/**
 * The same reader, for code that already has the PARSED body and the status.
 *
 * ⚠️ WHY A SIBLING RATHER THAN A FOURTH NEAR-COPY. The claim screens each fetch() directly
 * and read `res.json()`, so they cannot use apiErrorText above, which un-wraps the
 * `HTTP n: {json}` string that apiGet/postJson throw. Each of them had therefore grown its
 * own inline reader — and every one dropped `message`, which is the key XANO uses.
 *
 * That gap had a measured cost on 2026-09-15: ขอแก้ยอดเบิก was refused by api 636 with
 * "ต้องระบุเหตุผลที่ขอแก้ยอด" and the dialog rendered `HTTP 400`. Our Pages Functions answer
 * `{error, detail}`, but they forward Xano's body VERBATIM (`pass(res)`), so every
 * precondition written in XanoScript arrives with its sentence in `message` — a key nothing
 * on those screens was reading. The run guards, the voided-line guard and the
 * duplicate-request guard all had the same defect, for the same reason.
 *
 * Key order matches apiErrorText exactly, and must keep matching: `detail` is ours and is
 * written for a person, `message` is Xano's and is also written for a person, `error` is a
 * machine token and a poor last resort that still beats a bare number.
 */
export function apiErrorFromBody(body, status, fallback = 'ทำรายการไม่สำเร็จ') {
  const pick = (v) => {
    const s = String(v ?? '').trim()
    return s && s !== 'null' && s !== 'undefined' ? s : ''
  }
  const t = pick(body?.detail) || pick(body?.message) || pick(body?.error)
  if (t) return t
  return status ? `${fallback} (HTTP ${status})` : fallback
}
